import Image, { ImageProps } from 'next/legacy/image';
import { useState, type JSX } from 'react';
import { defaultImage, loader } from '../../utils/images';

export interface RawImageProps extends ImageProps {
  raw?: boolean;
  UNSAFE_className?: string;
}

const ResponsiveImage = ({
  raw = false,
  alt,
  src,
  UNSAFE_className = '',
  ...props
}: RawImageProps): JSX.Element => {
  const [hasError, setHasError] = useState(false);

  if (raw && typeof src === 'string') {
    const width = parseInt(`${props.width}`, 10) || 0;
    const source = loader({ src, width });

    return (
      <img
        alt={alt || ''}
        src={hasError || !source ? defaultImage : source}
        className={`responsive-image ${UNSAFE_className}`}
        onError={() => setHasError(true)}
        loading="lazy"
        {...props}
      />
    );
  }

  return (
    <Image
      loader={loader}
      alt={alt || ''}
      src={hasError || !src ? defaultImage : src}
      className={`responsive-image ${UNSAFE_className}`}
      placeholder="blur"
      blurDataURL={defaultImage}
      onError={() => {
        setHasError(true);
      }}
      {...props}
    />
  );
};

export default ResponsiveImage;
